import {
  GridToolbarItems,
  LinkExistingRecordGridButton,
  SubGrid,
  UnlinkExistingRecordGridButton,
} from '@powerportalspro/react-fluent';

// Same N:N relationship the Blazor `SubGridManyToManyDemo` uses —
// `ppp_Account_ppp_Region_ppp_Region` links the parent account to a set
// of regions. `<LinkExistingRecordGridButton>` opens a picker to attach
// an existing region (`Associate` request) and the unlink counterpart
// detaches one (`Disassociate`). `allowEdit` enables inline cell edits
// on the related rows themselves.
export function SubGridManyToManySample() {
  return (
    <SubGrid
      tableName="ppp_region"
      relationshipName="ppp_Account_ppp_Region_ppp_Region"
      pageSize={10}
      allowEdit
    >
      <GridToolbarItems>
        <LinkExistingRecordGridButton />
        <UnlinkExistingRecordGridButton />
      </GridToolbarItems>
    </SubGrid>
  );
}
